import { validate } from '@krugom/validator';
import store from '../../../store';
import { setToken } from '../../../store/reducer';

const setJWT = (arg?: any) => {
  const scheme = {
    type: 'string',
    pattern: /^[A-Za-z0-9_-]{2,}(?:\.[A-Za-z0-9_-]{2,}){2}$/,
  };
  const result = validate(arg, scheme);

  if (result.isValid) store.dispatch(setToken(arg as string));
};

export default setJWT;
